import { api } from "@/config/api";
import * as Sentry from "@sentry/react-native";
import type { AxiosError } from "axios";
import { Platform } from "expo-modules-core";

import { ReceiptFailReason } from "ipctg-inflow-types/InFlowEnums";
import type { ParkReceiptPOSTErrorResponse, ParkReceiptPOSTRequest, ParkReceiptPOSTSuccessResponse } from "ipctg-inflow-types/InFlowParkAPI";

export const fetchReceiptData = async (requestData: ParkReceiptPOSTRequest): Promise<ParkReceiptPOSTSuccessResponse> => {
  try {
    const response = await api.post<ParkReceiptPOSTSuccessResponse>("/receipt", requestData);
    return response.data;
  } catch (error) {
    Sentry.captureException(error, {
      extra: {
        data: requestData,
        localStorage: Platform.OS === "web" ? window.localStorage : null,
      },
    });
    const axiosError = error as AxiosError<ParkReceiptPOSTErrorResponse>;
    throw axiosError.response?.data ?? { failReason: ReceiptFailReason };
  }
};
